"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMobileAttributionLink = void 0;
// Consumer-Web OneLink created by common/frame/src/components/CTAFooter/OneLinkParams.ts is given the first priority since it contains attribution params that attribute clicks to Consumer Web Pages with specific WPV
// Generic OpenInAppLink and DownloadLink are given secondary priorities. These links attribute traffic is coming from the snapchat.com/download page.
function getMobileAttributionLink({ oneLink, openInAppLink, downloadLink, }) {
    return oneLink || openInAppLink || downloadLink;
}
exports.getMobileAttributionLink = getMobileAttributionLink;
//# sourceMappingURL=attribution.js.map